<script lang="ts">
	import EmeterAdvancedView from 'src/components/Sidepanel/DeviceViews/Emeter/EmeterAdvancedView.svelte';
	import type { Device } from 'src/types/Device';

	export let device: Device;
</script>

<EmeterAdvancedView {device} />
